/**
 * @generated SignedSource<<b6bf1378172ec65d544b06ae34011ed2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BookTypeEnum = "normal" | "school" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BookUpdateDialog_book$data = {
  readonly bookScrapCount: {
    readonly totalCount: number | null;
  };
  readonly coverPdf: {
    readonly key: string;
    readonly objectUrl: string;
  };
  readonly edition: string;
  readonly id: string;
  readonly problemPdf: {
    readonly key: string;
    readonly objectUrl: string;
  };
  readonly publisher: string;
  readonly solutionPdf: {
    readonly key: string;
    readonly objectUrl: string;
  };
  readonly title: string;
  readonly type: BookTypeEnum;
  readonly unitAs: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentType": "BookUpdateDialog_book";
};
export type BookUpdateDialog_book$key = {
  readonly " $data"?: BookUpdateDialog_book$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookUpdateDialog_book">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookUpdateDialog_book",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnitA",
      "kind": "LinkedField",
      "name": "unitAs",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publisher",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "edition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "coverPdf",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "problemPdf",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "solutionPdf",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "bookScrapCount",
      "args": null,
      "concreteType": "BookScrapConnection",
      "kind": "LinkedField",
      "name": "bookScraps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Book",
  "abstractKey": null
};
})();

(node as any).hash = "9ccf7eee20125c5cb1d155b16ae5248d";

export default node;
